import { render } from "./PopularProductsCarousel.vue?vue&type=template&id=690bf0db&scoped=true"
import script from "./PopularProductsCarousel.vue?vue&type=script&lang=js"
export * from "./PopularProductsCarousel.vue?vue&type=script&lang=js"

import "./PopularProductsCarousel.vue?vue&type=style&index=0&id=690bf0db&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690bf0db"]])

export default __exports__